export default {
  '@type': 'MerchantReturnPolicy',
  'applicableCountry': 'AT',
  'merchantReturnLink': 'https://www.timberland.at/de-at/kundenservice/ruckversand',
  'returnPolicyCategory': 'https://schema.org/MerchantReturnFiniteReturnWindow',
  'returnMethod': 'https://schema.org/ReturnByMail',
  'merchantReturnDays': 30
}
